import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FolderNavigationService {
  private currentFolderIdSubject: BehaviorSubject<number | null> =
    new BehaviorSubject<number | null>(null);

  getCurrentFolderId(): Observable<number | null> {
    return this.currentFolderIdSubject.asObservable();
  }

  setCurrentFolderId(folderId: number | null): void {
    this.currentFolderIdSubject.next(folderId);
  }
}
